<div class="records-container">
  <!-- Header -->
  <div class="records-header">
    <h2>Job Measurements</h2>
    <button class="close-btn" (click)="onCancel()" title="Close">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </button>
  </div>

  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-state">
    <div class="spinner"></div>
    <p>Loading records...</p>
  </div>

  <!-- Error State -->
  <div *ngIf="errorMessage && !isLoading" class="error-state">
    <p>{{ errorMessage }}</p>
  </div>

  <!-- Table -->
  <div *ngIf="!isLoading && !errorMessage" class="table-wrapper">
    <table class="records-table">
      <thead>
        <tr>
          <th>Job ID</th>
          <th>Megger Value</th>
          <th>PI Value</th>
          <th>Supervisor</th>
          <th>Date & Time</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of recordsData" class="table-row">
          <td>{{ data.job_id }}</td>
          <td class="numeric">{{ data.megger_value }}</td>
          <td class="numeric">{{ data.pi_value }}</td>
          <td>{{ data.supervisor_name }}</td>
          <td class="date">
  {{ convertUtcToIst(data.measured_at) }}
</td>

        </tr>
      </tbody>
    </table>
  </div>

  <!-- No Data State -->
  <div *ngIf="!isLoading && recordsData.length === 0 && !errorMessage" class="no-data-state">
    <p>No records found</p>
  </div>

  <!-- Footer -->
  <div class="records-footer" *ngIf="recordsData.length > 0">
    <span>{{ recordsData.length }} record(s)</span>
  </div>
</div>